{
  "name": "@qunhe/egs",
  "version": "1.2.91",
  "description": "Manycore EGS Graphics System",
  "license": "MIT",
  "main": "index.js",
  "types": "index.d.ts",
  "repository": "https://github.com/manycoretech/egs.git",
  "scripts": {
    "build": "pnpm egs-build",
    "build:release": "pnpm build --release",
    "build:types": "pnpm build --type-only",
    "build:types:release": "pnpm build --release --type-only",
    "generate:content-api": "pnpm generate-api-impl --target ./src/ContentAPI.ts --entry ContentAPI ContentManagedAPI",
    "generate:pipeline-api": "pnpm generate-api-impl --target ./src/fx/PipelineAPI.ts --entry PipelineAPI"
  },
  "dependencies": {
    "@qunhe/egs-lib": "^1.0.0",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@qunhe/egs-typings": "0.0.1",
    "typescript": "^6.0.3"
  },
  "release": {
    "scripts": {
      "pre-release": "pnpm build:release"
    },
    "publishRoot": "./build"
  },
  "typeOnlyExports": [
    {
      "name": "Viewport",
      "type": "class",
      "abstract": false
    }
  ]
}
